import { createContext } from "react";

interface languageContext {
    language: string
    changeLanguage: React.Dispatch<React.SetStateAction<string>>
}
  
export const LanguageContext = createContext<languageContext>({} as languageContext);
// export const LanguageContext = createContext({});
